import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithIam from '../../app/baseQueryWithIam'
import { CourseExamState, CuratorExamParticipationState, CuratorExamScoreRangeState, CuratorStudentAnalysisState, ListResponse } from '../types'

export const examAnalysisApiSlice = createApi({
    reducerPath: 'examAnalysisApi',
    baseQuery: baseQueryWithIam,
    tagTypes: ['Curator'],
    endpoints: (build) => ({
        fetchListOfExams: build.query<CourseExamState[], void>({
            query: () => ({
                url: `curator/exams`,
            }),
            providesTags: [{ type: 'Curator', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),

        fetchExamParticipation: build.query<CuratorExamParticipationState, { examId: number }>({
            query: ({ examId }) => ({
                url: `curator/exams/${examId}/participation`,
            }),
            providesTags: [{ type: 'Curator', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),

        fetchExamScoreRange: build.query<CuratorExamScoreRangeState, { examId: number }>({
            query: ({ examId }) => ({
                url: `curator/exams/${examId}/score-range`,
            }),
            providesTags: [{ type: 'Curator', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),

        fetchStudentAnalysis: build.query<ListResponse<CuratorStudentAnalysisState>, { examId: number; page: number; size: number }>({
            query: ({ examId, page, size }) => ({
                url: `curator/exams/${examId}/student-analysis`,
                params: {
                    page,
                    size,
                },
            }),
            providesTags: [{ type: 'Curator', id: 'LIST' }],
            transformResponse: (response: { data: ListResponse<CuratorStudentAnalysisState> }) => ({
                data: response.data.data,
                pageNumber: response.data.pageNumber,
                totalCount: response.data.totalCount,
                totalPages: response.data.totalPages,
            }),
        }),
    }),
})
